var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerkez(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.4,13.4c-.4,2.1-.7,3.2-1.3,4.6-.7,1.6-1.2,3-2.6,4-1,.7-2.2,1.2-3.9,1.3-7.2.5-14.4.6-21.5,1.8-1.8.3-2.9-.6-3.4-2.5C1.1,19.6.4,16.7,0,13.6c-.3-2.3.6-3.1,2.8-3.1,3.3,0,6.7-.6,9.9,0,3.3.7,9.5.9,22.3-.8-.1.9-.3,2.1-.6,3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerkez);
export default __webpack_public_path__ + "static/media/merkez.ef2253b58a146c274c17ccc93383ecc0.svg";
export { ForwardRef as ReactComponent };